import AWSLogo from "../../assets/language-logos/AWS.png";
import CSSLogo from "../../assets/language-logos/CSS3.png";
import ExpressLogo from "../../assets/language-logos/ExpressJS.png";
import HTMLLogo from "../../assets/language-logos/HTML5.png";
import JSLogo from "../../assets/language-logos/JavaScript.png";
import MongoDBLogo from "../../assets/language-logos/MongoDB.png";
import NodeJSLogo from "../../assets/language-logos/NodeJS.png";
import ReactNativeLogo from "../../assets/language-logos/React-Native.png";
import ReactLogo from "../../assets/language-logos/React.png";
import TSLogo from "../../assets/language-logos/TypeScript.png";

const data = [
    {id: 1, logo: HTMLLogo, name: "HTML5"},
    {id: 2, logo: CSSLogo, name: "CSS3"},
    {id: 3, logo: JSLogo, name: "JavaScript"},
    {id: 4, logo: TSLogo, name: "TypeScript"},
    {id: 5, logo: ReactLogo, name: "React"},
    {id: 6, logo: ReactNativeLogo, name: "React-Native"},
    {id: 7, logo: NodeJSLogo, name: "NodeJS"},
    {id: 8, logo: ExpressLogo, name: "ExpressJS"},
    {id: 9, logo: MongoDBLogo, name: "MongoDB"},
    {id: 10, logo: AWSLogo, name: "AWS"},
];

export default data;
